import { render } from "./TransactionList.vue?vue&type=template&id=685779aa&ts=true"
import script from "./TransactionList.vue?vue&type=script&lang=ts"
export * from "./TransactionList.vue?vue&type=script&lang=ts"

import "./TransactionList.vue?vue&type=style&index=0&id=685779aa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__